export const errorMessages = {
    LOCATION_NOT_FOUND_ERROR: 'Location not found, please enter another location.',
    NO_STORES_FOUND_ERROR: 'No stores have been found for the location, please enter another location.',
    GEOLOCATION_ERROR: 'Unable to fetch your geolocation, please try typing your location.',
    TECHNICAL_ERROR: 'A technical error has occured, please try again later.',
};
